/* 拼接get请求的url参数*/
export function get_url_deal(url, data) {
  if (data) {
    url += '?'
    for (let k in data) {
      const v = data[k]
      if (v && v !== '') {
        k = k === 'n' ? 'name' : k
        url += (k + '=') + v + '&'
      }
    }
    url += 'zzz='
  }
  return url
}
